import { useLayoutEffect } from 'react';

const useScrollTo = (x, y, ref, dependency = []) => {
  const element = ref?.current ?? window;
  useLayoutEffect(() => {
    try {
      element.scrollTo({ top: x, left: y, behavior: 'smooth' });
    } catch (error) {
      element.scrollTo(x, y);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, dependency);
};

export default useScrollTo;
